module.exports = __webpack_public_path__ + "img/celestial-cathedral.71ee2117.jpg";